import styled, { keyframes } from 'styled-components';

// Animacao de entrada do modal — scale + fade rapido pra dar
// sensacao de "appearing" sem virar distracao.
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleUp = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: scale(1); }
`;

// Scrim — overlay escuro com blur que cobre toda a tela e centraliza
// o modal no viewport. Click no scrim (nao no modal) fecha.
export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: grid;
  place-items: center;
  padding: 24px;
  animation: ${fadeIn} 0.15s ease-out;

  @media (max-width: 720px) {
    padding: 0;
  }
`;

// Container principal do modal. Largura cap em 1040px (igual design
// Maquinas.html) com flex-column pra header/tabs/body/foot empilharem
// e o body ficar scrollavel.
export const Modal = styled.div`
  width: min(1040px, 100%);
  height: ${(props) =>
    props.$variableTab ? 'calc(100vh - 48px)' : 'auto'};
  max-height: calc(100vh - 48px);
  background: var(--cco-surface);
  border: 1px solid var(--cco-line-strong);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${scaleUp} 0.18s ease-out;

  @media (max-width: 720px) {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
  }
`;

export const SuggestionScrim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 80;
  background: rgba(0, 0, 0, 0.66);
  backdrop-filter: blur(3px);
  display: grid;
  place-items: center;
  padding: 24px;
  animation: ${fadeIn} 0.15s ease-out;

  @media (max-width: 720px) {
    padding: 10px;
  }
`;

export const SuggestionModal = styled.div`
  width: min(880px, 100%);
  max-height: calc(100vh - 96px);
  background: var(--cco-surface);
  border: 1px solid var(--cco-line-strong);
  border-radius: 14px;
  box-shadow: 0 20px 70px rgba(0, 0, 0, 0.42);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: ${scaleUp} 0.16s ease-out;

  @media (max-width: 720px) {
    max-height: calc(100vh - 20px);
  }
`;

export const SuggestionHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid var(--cco-line);
`;

export const SuggestionToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  padding: 14px 24px;
  border-bottom: 1px solid var(--cco-line);
  color: var(--cco-ink-mute);
  font-size: 13px;

  @media (max-width: 520px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`;

export const SuggestionList = styled.div`
  overflow: auto;
  padding: 8px;
`;

export const SuggestionItem = styled.div`
  display: grid;
  grid-template-columns: minmax(140px, 190px) minmax(0, 1fr) 86px;
  align-items: center;
  gap: 14px;
  min-height: 42px;
  padding: 8px 14px;
  border-radius: 8px;
  color: var(--cco-ink);
  background: ${(props) =>
    props.$on ? 'rgba(28, 176, 216, 0.08)' : 'transparent'};

  &:hover {
    background: var(--cco-soft-surface);
  }

  .suggestion-name {
    font-weight: 800;
  }

  .suggestion-description,
  .suggestion-unit {
    color: var(--cco-ink-mute);
    font-size: 13px;
  }

  .suggestion-description {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  .suggestion-unit {
    text-align: right;
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
    align-items: flex-start;
    gap: 5px;

    .suggestion-unit {
      text-align: left;
    }
  }
`;

export const SuggestionFoot = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 24px 20px;
  border-top: 1px solid var(--cco-line);

  @media (max-width: 520px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 24px var(--cco-pad) 0;

  @media (max-width: 480px) {
    padding: 12px var(--cco-pad) 0;
  }
`;

export const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0;
  color: var(--cco-ink);
`;

export const Desc = styled.div`
  font-size: 13.5px;
  color: var(--cco-ink-mute);
  margin-top: 4px;
`;

export const ReqHint = styled.div`
  font-size: 11.5px;
  color: var(--cco-ink-faint);
  margin-top: 8px;
  letter-spacing: 0.04em;

  .req {
    color: var(--cco-red);
    margin-right: 3px;
  }
`;

export const Close = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--cco-soft-surface);
  border: 1px solid var(--cco-line);
  display: grid;
  place-items: center;
  color: var(--cco-ink-mute);
  transition: all 0.15s;
  flex: none;
  cursor: pointer;
  padding: 0;
  font-size: 16px;
  line-height: 1;

  &:hover {
    background: rgba(244, 68, 92, 0.1);
    color: var(--cco-red);
    border-color: rgba(244, 68, 92, 0.4);
  }
`;

// Tabs no topo do modal — exibidos apenas em modo edicao porque
// criar maquina ainda nao tem thingId pra vincular variaveis.
export const TabsRow = styled.div`
  display: flex;
  gap: 0;
  padding: 18px var(--cco-pad) 0;
  border-bottom: 1px solid var(--cco-line);
`;

export const TabButton = styled.button`
  padding: 12px 4px;
  margin-right: 32px;
  margin-bottom: -1px;
  background: transparent;
  border: 0;
  color: ${(props) => (props.$active ? 'var(--cco-cyan)' : 'var(--cco-ink-mute)')};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.$active ? 'var(--cco-cyan)' : 'transparent')};
  transition: color 0.15s, border-color 0.15s;

  &:hover {
    color: var(--cco-ink);
  }
`;

export const ModalBody = styled.div`
  padding: 24px var(--cco-pad);
  overflow-y: auto;
  flex: 1;
  min-height: 0;

  ${(props) =>
    props.$variableTab &&
    `
      display: flex;
      flex-direction: column;
      overflow: hidden;
    `}
`;

// Toggle "usar aplicacao existente" — linha com switch + label,
// vive logo no topo do body quando criando nova maquina.
export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--cco-line);

  .toggle-label {
    font-size: 13.5px;
    font-weight: 600;
    color: var(--cco-ink);
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  ${(props) => props.$full && 'grid-column: 1 / -1;'}
`;

export const Label = styled.label`
  font-size: 13.5px;
  font-weight: 600;
  color: var(--cco-ink);

  .req {
    color: var(--cco-red);
    margin-left: 2px;
  }
`;

// Input nativo styled — pill arredondado (border-radius 999px) seguindo
// padrao de filtros das telas redesenhadas.
export const Input = styled.input`
  appearance: none;
  -webkit-appearance: none;
  height: 44px;
  padding: 0 16px;
  background: var(--cco-soft-surface-2);
  border: 1px solid var(--cco-line);
  border-radius: 999px;
  color: var(--cco-ink);
  font: inherit;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
  width: 100%;
  box-sizing: border-box;

  &::placeholder {
    color: var(--cco-ink-faint);
  }

  &:focus {
    border-color: var(--cco-cyan);
    background: rgba(28, 176, 216, 0.04);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  height: 44px;
  padding: 0 42px 0 16px;
  background: var(--cco-soft-surface-2);
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'><path fill='rgba(255,255,255,.5)' d='M0 0h12L6 8z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 16px center;
  border: 1px solid var(--cco-line);
  border-radius: 999px;
  color: var(--cco-ink);
  font: inherit;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: var(--cco-cyan);
    background-color: rgba(28, 176, 216, 0.04);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  option {
    background: #0a0a0b;
    color: var(--cco-ink);
  }
`;

// Wrapper pro AsyncSelect — alinha altura e contem o componente sem
// que o estilo herde nada do scope global.
export const AsyncWrap = styled.div`
  width: 100%;
`;

// Group section dentro do body (Setpoints / Comandos). Espaca do
// FormGrid acima e da margem propria pro h3.
export const Group = styled.div`
  margin-top: 28px;
`;

export const GroupTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--cco-ink);
`;

export const Checks2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Checks3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px 24px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

// Linha de check — clicavel inteira com checkbox custom (.box) + label.
// O input nativo fica escondido (sr-only) pra preservar acessibilidade
// e validacao via teclado.
export const Check = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  color: var(--cco-ink);
  font-size: 13.5px;
  transition: color 0.15s;

  &:hover {
    color: var(--cco-cyan);
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }

  .box {
    width: 18px;
    height: 18px;
    border-radius: 5px;
    flex: none;
    border: 1.5px solid var(--cco-line-strong);
    background: var(--cco-soft-surface-2);
    display: grid;
    place-items: center;
    transition: all 0.15s;
    color: #0a0a0b;
  }

  .box svg {
    width: 12px;
    height: 12px;
    opacity: 0;
    transition: opacity 0.15s;
  }

  ${(props) =>
    props.$on &&
    `
    .box {
      background: var(--cco-cyan);
      border-color: var(--cco-cyan);
    }
    .box svg {
      opacity: 1;
    }
  `}
`;

// Estado de sucesso — substitui o body do modal com icon + mensagem.
export const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 32px 16px;
  gap: 18px;
`;

export const SuccessIcon = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

export const SuccessText = styled.div`
  color: var(--cco-ink);
  font-size: 18px;
  font-weight: 700;
`;

export const ModalFoot = styled.div`
  padding: 18px var(--cco-pad) 24px;
  border-top: 1px solid var(--cco-line);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;

  @media (max-width: 480px) {
    padding: 12px var(--cco-pad);
    flex-wrap: wrap;
  }
`;

export const ConfirmText = styled.div`
  color: var(--cco-ink-mute);
  font-size: 13px;
  margin-right: auto;
`;

export const SaveBtn = styled.button`
  height: 44px;
  padding: 0 32px;
  background: var(--cco-cyan);
  color: #06151a;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border-radius: 10px;
  border: 0;
  cursor: pointer;
  transition: filter 0.15s, background 0.15s, opacity 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;

  &:hover:not(:disabled) {
    background: #3ec0e0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const CancelBtn = styled.button`
  height: 44px;
  padding: 0 22px;
  background: transparent;
  color: var(--cco-ink-mute);
  border: 1px solid var(--cco-line);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.15s;

  &:hover {
    background: var(--cco-soft-surface);
    color: var(--cco-ink);
    border-color: var(--cco-line-strong);
  }
`;

// Styles do react-select/async pra casar com .input do design.
// Mantemos o componente AsyncSelect porque ele tem busca async server-side
// (handleSearchAppliance) que select nativo nao suporta. Toda a aparencia
// (control, menu, option, single value) eh override aqui.
export const getAsyncSelectStyles = () => ({
  control: (provided, state) => ({
    ...provided,
    minHeight: 44,
    height: 44,
    background: state.isFocused
      ? 'rgba(28, 176, 216, 0.04)'
      : 'var(--cco-soft-surface-2)',
    borderRadius: 999,
    borderColor: state.isFocused
      ? 'var(--cco-cyan)'
      : 'var(--cco-line)',
    boxShadow: 'none',
    paddingLeft: 6,
    cursor: 'pointer',
    '&:hover': {
      borderColor: state.isFocused
        ? 'var(--cco-cyan)'
        : 'var(--cco-line-strong)',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
  }),
  input: (provided) => ({
    ...provided,
    color: 'var(--cco-ink)',
    fontSize: 14,
    margin: 0,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'var(--cco-ink-faint)',
    fontSize: 14,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'var(--cco-ink)',
    fontSize: 14,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: 'var(--cco-ink-mute)',
    padding: '0 12px',
    '&:hover': { color: 'var(--cco-ink)' },
  }),
  loadingIndicator: (provided) => ({
    ...provided,
    color: 'var(--cco-cyan)',
  }),
  menu: (provided) => ({
    ...provided,
    background: '#0e0f12',
    border: '1px solid var(--cco-line)',
    borderRadius: 12,
    overflow: 'hidden',
    zIndex: 1001,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 220,
    padding: 4,
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected
      ? 'var(--cco-cyan-soft)'
      : state.isFocused
      ? 'var(--cco-soft-surface)'
      : 'transparent',
    color: state.isSelected ? 'var(--cco-cyan)' : 'var(--cco-ink)',
    fontSize: 14,
    borderRadius: 8,
    cursor: 'pointer',
    padding: '10px 12px',
    '&:active': {
      background: 'var(--cco-cyan-soft)',
    },
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: 'var(--cco-ink-mute)',
    fontSize: 13,
  }),
  loadingMessage: (provided) => ({
    ...provided,
    color: 'var(--cco-ink-mute)',
    fontSize: 13,
  }),
});
